import { useWidgetStore } from "../stores/widget-store";

export const useWidgets = () => {
	const widgets = useWidgetStore((state) => state.widgets);
	const templates = useWidgetStore((state) => state.templates);
	const templateDetail = useWidgetStore((state) => state.templateDetail);
	const indexWidgets = useWidgetStore((state) => state.index);
	const showWidget = useWidgetStore((state) => state.show);
	const createWidget = useWidgetStore((state) => state.create);
	const updateWidget = useWidgetStore((state) => state.update);
	const deleteWidget = useWidgetStore((state) => state.delete);
	const previewWidget = useWidgetStore((state) => state.preview);
	const listTemplates = useWidgetStore((state) => state.listTemplates);
	const showTemplate = useWidgetStore((state) => state.showTemplate);
	const indexPinnedReviewIds = useWidgetStore((state) => state.indexPinnedReviewIds);
	const indexCuratedReviewIds = useWidgetStore((state) => state.indexCuratedReviewIds);
	const syncPinnedReviews = useWidgetStore((state) => state.syncPinnedReviews);
	const syncCuratedReviews = useWidgetStore((state) => state.syncCuratedReviews);
	const aggregationPreview = useWidgetStore((state) => state.aggregationPreview);

	return {
		widgets,
		templates,
		templateDetail,
		indexWidgets,
		showWidget,
		createWidget,
		updateWidget,
		deleteWidget,
		previewWidget,
		listTemplates,
		showTemplate,
		indexPinnedReviewIds,
		indexCuratedReviewIds,
		syncPinnedReviews,
		syncCuratedReviews,
		aggregationPreview,
	};
};
